module.exports = __webpack_public_path__ + "img/36-zjly.fc16f6b4.png";